import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import Loading from "./loader";
import closeImage from "./images/close.png";
import {EllipsisOutlined, InfoCircleOutlined, ArrowLeftOutlined, CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import {Tooltip, Dropdown, Menu} from "antd";
import StateWarning from './StateWarning';

class VoteRegUsers extends Component {
    state = {
        accounts: [],
        totalUsersCount: 0,
        currentPage: 1,
        pageSize: 10,
        searchQuery: '',
        selectedAccount: null,
        selectedIndex: null,
        filters: [],
        isLoading: true,
        sortBy: 'account_fullname',
        sortDirection: 'asc',
        meetingName: ''
    };

    async componentDidMount() {
        const { is_staff, is_superuser } = this.props;
        if (!is_staff && !is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        await this.loadAccounts();
    }

    async componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;
        if (
            prevProps.is_staff !== this.props.is_staff ||
            prevProps.is_superuser !== this.props.is_superuser
        ) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    getRenderKey() {
        const { currentPage, pageSize, sortBy, sortDirection, filters, searchQuery } = this.state;
        return `reg-users-${currentPage}-${pageSize}-${sortBy}-${sortDirection}-${filters.length}-${searchQuery}`;
    }

    loadAccounts = async () => {
      const { match } = this.props;
      const meetingId = match.params.meetingId;
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
      try {
        // Загружаем зарегистрированных пользователей
        const accountsResponse = await fetch(`${API_ADDRESS}get_reg_pac_votes/${meetingId}/`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (accountsResponse.ok) {
          const accountsData = await accountsResponse.json();

          // Загружаем информацию о собрании
          const meetingResponse = await fetch(`${API_ADDRESS}get_meeting_name/${meetingId}/`, {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          });

          let meetingName = '';
          if (meetingResponse.ok) {
            const meetingData = await meetingResponse.json();
            meetingName = meetingData.meeting_name || '';
          }

          this.setState({
            accounts: accountsData,
            meetingName: meetingName,
            isLoading: false,
          });
        } else {
          alert("Произошла ошибка. Попробуйте еще раз открыть раздел.");
          this.setState({ isLoading: false });
        }
      } catch (e) {
        console.error(e);
        alert("Произошла ошибка. Попробуйте еще раз открыть раздел.");
        this.setState({ isLoading: false });
      }
    };

    getPaginatedAccounts = () => {
        const { accounts, currentPage, pageSize, searchQuery, filters, sortBy, sortDirection } = this.state;

        // Фильтрация
        let filteredAccounts = accounts.filter((account) =>
            account.account_fullname.toLowerCase().includes(searchQuery.toLowerCase()) ||
            account.account_id.toString().includes(searchQuery)
        );

        if (filters.length > 0) {
            filteredAccounts = filteredAccounts.filter((account) =>
                filters.every((filter) =>
                    account.account_fullname.toLowerCase().includes(filter.toLowerCase()) ||
                    account.account_id.toString().includes(filter)
                )
            );
        }

        // Сортировка
        const sortedAccounts = [...filteredAccounts].sort((a, b) => {
            const order = sortDirection === 'asc' ? 1 : -1; // asc = А-Я

            if (sortBy === 'account_fullname') {
                const nameA = (a.account_fullname || '').trim().toUpperCase();
                const nameB = (b.account_fullname || '').trim().toUpperCase();

                const isARussian = /^[А-ЯЁ]/.test(nameA);
                const isBRussian = /^[А-ЯЁ]/.test(nameB);

                if (isARussian && isBRussian) {
                    return nameA.localeCompare(nameB, 'ru-RU') * order;
                }
                if (!isARussian && !isBRussian) {
                    return nameA.localeCompare(nameB, 'en-US') * order;
                }
                return (isARussian ? -1 : 1) * order;
            }

            // Сортировка по дате и времени регистрации
            if (sortBy === 'dt_registered') {
                const dateA = a.dt_registered ? new Date(a.dt_registered) : null;
                const dateB = b.dt_registered ? new Date(b.dt_registered) : null;

                // Если одна из дат отсутствует, помещаем её в конец
                if (!dateA && !dateB) return 0;
                if (!dateA) return 1 * order;
                if (!dateB) return -1 * order;

                return (dateA - dateB) * order;
            }

            return 0;
        });

        // Пагинация
        const startIndex = (currentPage - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        return sortedAccounts.slice(startIndex, endIndex);
    };

    handleSort = (field) => {
        this.setState(
            (prevState) => {
                let newDirection = 'asc';
                let newSortBy = field;

                if (prevState.sortBy === field) {
                    newDirection = prevState.sortDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    newDirection = 'asc';
                }

                return {
                    sortBy: newSortBy,
                    sortDirection: newDirection,
                    currentPage: 1,
                    selectedIndex: null,
                    selectedAccount: null,
                };
            },
            this.getPaginatedAccounts
        );
    };

    getSortIndicator = (field) => {
        const { sortBy, sortDirection } = this.state;
        if (sortBy !== field) {
            return { activeAsc: false, activeDesc: false };
        }
        return {
            activeAsc: sortDirection === 'asc',
            activeDesc: sortDirection === 'desc'
        };
    };

    handleSearchChange = (e) => {
        const { value } = e.target;
        this.setState({ searchQuery: value });
        if (e.key === 'Enter' && value.trim() !== '') {
            this.setState((prevState) => ({
                filters: [...prevState.filters, value.trim()],
                searchQuery: '',
                currentPage: 1,
                selectedIndex: null,
                selectedUser: null,
            }));
        }
    };

    removeFilter = (filterToRemove) => {
        this.setState((prevState) => ({
            filters: prevState.filters.filter((filter) => filter !== filterToRemove),
            currentPage: 1,
            selectedIndex: null,
            selectedUser: null,
        }));
    };

    handleBackClick = () => {
        window.history.back();
    };

    resultVoteClick = () => {
        const { match } = this.props;
        const { accounts, selectedIndex } = this.state;
        if (selectedIndex === null) return;

        const selectedAccount = accounts[selectedIndex];
        const { account_id, vote_count_id, uniquifier } = selectedAccount;
        const meetingId = match.params.meetingId;

        window.location.href = `/#/voteOneResult/${meetingId}/${account_id}/${uniquifier}/${vote_count_id}`;
    };

    renderFilters() {
        const { filters } = this.state;
        return (
            <div className="filters-container">
                {filters.map((filter, index) => (
                    <div key={index} className="filter-tag">
                        {filter}
                        <img
                            src={closeImage}
                            alt="Удалить"
                            style={{
                                cursor: 'pointer',
                                width: '15px',
                                height: '15px'
                            }}
                            onClick={() => this.removeFilter(filter)}
                        />
                    </div>
                ))}
            </div>
        );
    }

    selectItem = (index) => {
        const { selectedIndex, accounts } = this.state;
        const paginatedAccounts = this.getPaginatedAccounts();

        if (selectedIndex === index) {
            this.setState({ selectedIndex: null, selectedAccount: null });
        } else {
            this.setState({ selectedIndex: index }, () => {
                setTimeout(() => {
                    const row = document.querySelector(`.adm-table tbody tr:nth-child(${index + 1})`);
                    const wrapper = document.querySelector('.table-wrapper');

                    if (row && wrapper) {
                        const rowRect = row.getBoundingClientRect();
                        const wrapperRect = wrapper.getBoundingClientRect();
                        const top = rowRect.top - wrapperRect.top + rowRect.height / 2;

                        this.setState({
                            selectedAccount: {
                                data: paginatedAccounts[index],
                                rowTop: top,
                                index: index,
                            },
                        });
                    }
                }, 0);
            });
        }
    };

    // --- Метод пагинации ---
    renderPagination = (totalPages) => {
        const { currentPage } = this.state;
        const groupSize = 10;
        const currentGroup = Math.ceil(currentPage / groupSize);
        const startPage = (currentGroup - 1) * groupSize + 1;
        const endPage = Math.min(currentGroup * groupSize, totalPages);

        const goToPage = (page) => {
            if (page >= 1 && page <= totalPages) {
                this.setState({
                    currentPage: page,
                    selectedIndex: null,
                    selectedUser: null,
                });
            }
        };

        const goToPrevGroup = () => {
            const prevStart = startPage - groupSize;
            const newPage = prevStart >= 1 ? prevStart : 1;
            this.setState({
                currentPage: newPage,
                selectedIndex: null,
                selectedUser: null,
            });
        };

        const goToNextGroup = () => {
            const nextStart = startPage + groupSize;
            if (nextStart <= totalPages) {
                this.setState({
                    currentPage: nextStart,
                    selectedIndex: null,
                    selectedUser: null,
                });
            }
        };

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', width: '100%' }}>
                {/* Первая строка — номера страниц */}
                <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                        const page = startPage + i;
                        return (
                            <button5
                                key={page}
                                className={`pagination-button ${currentPage === page ? 'active' : ''}`}
                                onClick={() => goToPage(page)}
                            >
                                {page}
                            </button5>
                        );
                    })}
                </div>

                {/* Вторая строка — стрелки*/}
                {(currentGroup > 1 || currentGroup * groupSize < totalPages) && (
                    <div style={{ display: 'flex', gap: '6px', marginTop: '8px' }}>
                        {currentGroup > 1 && (
                            <button5
                                className="pagination-button"
                                onClick={goToPrevGroup}
                                style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                aria-label="Предыдущие 10 страниц"
                            >
                                <CaretLeftOutlined style={{ fontSize: '12px' }} />
                            </button5>
                        )}
                        {currentGroup * groupSize < totalPages && (
                            <button5
                                className="pagination-button"
                                onClick={goToNextGroup}
                                style={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                aria-label="Следующие 10 страниц"
                            >
                                <CaretRightOutlined style={{ fontSize: '12px' }} />
                            </button5>
                        )}
                    </div>
                )}
            </div>
        );
    };

    formatDateTime = (isoString) => {
        if (!isoString) return '-';
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}.${month}.${year} ${hours}:${minutes}`;
    };

    render() {
        const {accounts, pageSize, currentPage, searchQuery, selectedIndex, filters} = this.state;

        let filteredAccounts = accounts.filter((account) =>
            account.account_fullname.toLowerCase().includes(searchQuery.toLowerCase()) ||
            account.account_id.toString().includes(searchQuery)
        );

        if (this.state.filters.length > 0) {
            filteredAccounts = filteredAccounts.filter((account) =>
                this.state.filters.every((filter) =>
                    account.account_fullname.toLowerCase().includes(filter.toLowerCase()) ||
                    account.account_id.toString().includes(filter)
                )
            );
        }

        const paginatedAccounts = this.getPaginatedAccounts();

        const totalPages = Math.ceil(filteredAccounts.length / pageSize);

        const voteActionMenu = (index) => (
            <Menu>
                <Menu.Item
                    key="result"
                    onClick={() => {
                        this.setState({ selectedIndex: index }, () => {
                            this.resultVoteClick();
                        });
                    }}
                >
                    Результат голосования
                </Menu.Item>
            </Menu>
        );

        if (this.state.isLoading) {
            return <div><Loading /></div>;
        }

        return (
            <>
                <div className="page-container">
                    <div className="header-container">
                        <div style={{display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px'}}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1>Зарегистрированные пользователи собрания</h1>
                        </div>
                    </div>
                    {accounts.length > 0 && (
                        <div className="search-input">
                            <input
                                type="text"
                                placeholder="Поиск..."
                                value={searchQuery}
                                onChange={this.handleSearchChange}
                                onKeyDown={this.handleSearchChange}
                                className="main-input4 default-text-style"
                            />
                            <Tooltip
                                title="В строке можно использовать последовательную фильтрацию по разным условиям. Нажмите Enter после ввода данных для создания одного условия"
                                placement="right">
                                <InfoCircleOutlined style={{fontSize: '18px', color: '#000', cursor: 'pointer'}}/>
                            </Tooltip>
                        </div>
                    )}
                    <div className="search-tags">
                        {this.renderFilters()}
                    </div>

                    {this.state.meetingName && paginatedAccounts.length > 0 && (
                      <div className="username-container">
                        <b>Собрание:</b>{' '}
                        <span className="username-badge">
                          {this.state.meetingName}
                        </span>
                      </div>
                    )}

                    {paginatedAccounts.length !== 0 ? (
                        <div className="table-wrapper">
                            <div
                                key={this.getRenderKey()}
                                className="table-animated-container"
                                style={{
                                    opacity: 0,
                                    animation: 'fadeIn 0.3s ease-in-out forwards'
                                }}
                            >
                                <div className="table-adm-container">
                                    <table className="adm-table">
                                        <thead>
                                        <tr>
                                            <th>№</th>
                                            <th
                                                onClick={() => this.handleSort('account_fullname')}
                                                style={{cursor: 'pointer', position: 'relative', whiteSpace: 'normal'}}
                                            >
                                                Имя
                                                <span style={{marginLeft: '8px', fontSize: '14px', marginTop: '-10px'}}>
                                                    <span
                                                        style={{
                                                            color: this.getSortIndicator('account_fullname').activeAsc ? '#007bff' : '#666',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        ↑
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: this.getSortIndicator('account_fullname').activeDesc ? '#007bff' : '#666',
                                                            fontWeight: 'bold',
                                                            marginLeft: '1px'
                                                        }}
                                                    >
                                                        ↓
                                                    </span>
                                                </span>
                                            </th>
                                            <th>Номер счета</th>
                                            <th
                                                onClick={() => this.handleSort('dt_registered')}
                                                style={{cursor: 'pointer', position: 'relative', whiteSpace: 'normal'}}
                                            >
                                                Дата и время регистрации на собрание
                                                <span style={{marginLeft: '8px', fontSize: '14px', marginTop: '-10px'}}>
                                                    <span
                                                        style={{
                                                            color: this.getSortIndicator('dt_registered').activeAsc ? '#007bff' : '#666',
                                                            fontWeight: 'bold'
                                                        }}
                                                    >
                                                        ↑
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: this.getSortIndicator('dt_registered').activeDesc ? '#007bff' : '#666',
                                                            fontWeight: 'bold',
                                                            marginLeft: '1px'
                                                        }}
                                                    >
                                                        ↓
                                                    </span>
                                                </span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {paginatedAccounts.map((account, index) => {
                                            const globalIndex = (currentPage - 1) * pageSize + index + 1;
                                            const isSelected = selectedIndex === index;
                                            return (
                                                <tr
                                                    key={account.account_id}
                                                    className={isSelected ? 'selected' : ''}
                                                    onClick={() => this.selectItem(index)}
                                                    style={{cursor: 'pointer'}}
                                                >
                                                    <td>{globalIndex}</td>
                                                    <td>{account.account_fullname || "-"}</td>
                                                    <td>
                                                        {account.uniquifier === 0
                                                            ? account.account_id
                                                            : `${account.account_id} - ${account.uniquifier}`
                                                        }
                                                    </td>
                                                    <td>{this.formatDateTime(account.dt_registered)}</td>
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>

                                    {/* Пагинация */}
                                    <div className="pagination-container">
                                        {totalPages > 1 && this.renderPagination(totalPages)}
                                    </div>
                                </div>
                            </div>

                            {/* Контекстная кнопка снаружи таблицы */}
                            {this.state.selectedAccount && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        left: 'calc(50% + 25% + 10px)',
                                        top: this.state.selectedAccount.rowTop,
                                        transform: 'translateY(-50%)',
                                        zIndex: 10,
                                        backgroundColor: 'white',
                                        padding: '5px 8px',
                                        border: '1px solid #000',
                                        borderRadius: '4px',
                                        boxShadow: '0 0 5px rgba(0,0,0,0.1)',
                                    }}
                                >
                                    <Dropdown
                                        overlay={
                                            <Menu>
                                                <Menu.Item
                                                    key="result"
                                                    onClick={() => {
                                                        this.setState({selectedIndex: this.state.selectedAccount.index}, () => {
                                                            this.resultVoteClick();
                                                        });
                                                    }}
                                                >
                                                    Результат голосования
                                                </Menu.Item>
                                            </Menu>
                                        }
                                        trigger={['click']}
                                    >
                                        <EllipsisOutlined
                                            style={{
                                                fontSize: '18px',
                                                cursor: 'pointer',
                                                color: '#1890ff',
                                            }}
                                        />
                                    </Dropdown>
                                </div>
                            )}
                        </div>
                    ) : (
                        <>
                            <StateWarning message={`Пользователи отсутствуют для собрания (${this.state.meetingName})`} />
                        </>
                    )}
                </div>
            </>
        );
    }
}

export default withRouter(VoteRegUsers);